/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetExpensePosition } from './AssetExpensePosition';
import {
    AssetExpensePositionFromJSON,
    AssetExpensePositionFromJSONTyped,
    AssetExpensePositionToJSON,
    AssetExpensePositionToJSONTyped,
} from './AssetExpensePosition';

/**
 * 
 * @export
 * @interface AssetExpenseResponse
 */
export interface AssetExpenseResponse {
    /**
     * 
     * @type {AssetExpensePosition}
     * @memberof AssetExpenseResponse
     */
    position: AssetExpensePosition;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseResponse
     */
    amount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseResponse
     */
    debtorShare: number;
}



/**
 * Check if a given object implements the AssetExpenseResponse interface.
 */
export function instanceOfAssetExpenseResponse(value: object): value is AssetExpenseResponse {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('debtorShare' in value) || value['debtorShare'] === undefined) return false;
    return true;
}

export function AssetExpenseResponseFromJSON(json: any): AssetExpenseResponse {
    return AssetExpenseResponseFromJSONTyped(json, false);
}

export function AssetExpenseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetExpenseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'position': AssetExpensePositionFromJSON(json['position']),
        'amount': json['amount'],
        'debtorShare': json['debtorShare'],
    };
}

export function AssetExpenseResponseToJSON(json: any): AssetExpenseResponse {
    return AssetExpenseResponseToJSONTyped(json, false);
}

export function AssetExpenseResponseToJSONTyped(value?: AssetExpenseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': AssetExpensePositionToJSON(value['position']),
        'amount': value['amount'],
        'debtorShare': value['debtorShare'],
    };
}

